export const RiskRatingConfigurationsPermissions = {
  ViewRiskRatingConfigurations : {
     permissionsId: "9b0964d4-fc2c-447e-5175-08dce7a01c4d",
     permissionsName: "View Risk Rating Configurations",
     description: null,
     componentsId: null,
     components : null
  }
};
